<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <form>
          <div class="my-5"></div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.countrySelected.$error }">
                <div class="fg-line">
                    <label>País actual:</label>
                    <div class="select">
                        <select v-model="item.countrySelected" id="countryCode" @change="getProvinces(item.countrySelected)" name="countrySelected" class="form-control"><!-- v-validate="'required'"-->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="country of countries" :key="country.code_iso_alfa3" :value="country">{{ country.common_name }}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.countrySelected.required">Campo requerido</div>
                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
            <div class="col-sm-3">
            <div class="form-group" :class="{ 'form-group--error': $v.item.provinceSelected.$error }">
                <div class="fg-line">
                    <label>Provincia actual:</label>
                    <div class="select">
                        <select v-model="item.provinceSelected" id="ProvinceCode" name="provinceSelected" class="form-control"> <!-- v-validate="'required'" -->
                            <option value="">[Seleccione una opción]</option>
                            <option v-for="province of provinces" :key="province.code_iso" :value="province">{{ province.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="error" v-if="!$v.item.provinceSelected.required">Campo requerido</div>

                <!-- <small v-if="errors.has('countryCode')" class="help-block">{{ errors.first('countryCode') }}</small> -->
            </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.location.$error }">
                <label for="city">Ciudad</label>
                <input
                  type="text"
                  class="form-control"
                  id="city"
                  aria-describedby="emailHelp"
                  v-model="item.location"
                />
                <div class="error" v-if="!$v.item.location.required">Campo requerido</div>

              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.postalCode.$error }">
                <label for="postalCode">Código postal</label>
                <input
                  type="text"
                  class="form-control"
                  id="postalCode"
                  aria-describedby="emailHelp"
                  v-model="item.postalCode"
                />
                <div class="error" v-if="!$v.item.postalCode.required">Campo requerido</div>

              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.neighborhood.$error }">
                <label for="neighborhood">Barrio</label>
                <input
                  type="text"
                  class="form-control"
                  id="neighborhood"
                  aria-describedby="emailHelp"
                  v-model="item.neighborhood"
                />
                <div class="error" v-if="!$v.item.neighborhood.required">Campo requerido</div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" :class="{ 'form-group--error': $v.item.street.$error }">
                <label for="street">Calle</label>
                  <input
                    type="text"
                    class="form-control"
                    id="street"
                    aria-describedby="emailHelp"
                    v-model="item.street"
                  />
                  <div class="error" v-if="!$v.item.street.required">Campo requerido</div>

              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1" :class="{ 'form-group--error': $v.item.streetNumber.$error }">
              <div class="form-group">
                <label for="streetNumber">Número de calle</label>
                <input
                  type="text"
                  class="form-control"
                  id="streetNumber"
                  aria-describedby="emailHelp"
                  v-model="item.streetNumber"
                />
                <div class="error" v-if="!$v.item.streetNumber.required">Campo requerido</div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="floorNumber">Piso</label>
                <input
                  type="text"
                  class="form-control"
                  id="floorNumber"
                  aria-describedby="emailHelp"
                  v-model="item.floorNumber"
                />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label for="department">Departamento</label>
                <input
                  type="text"
                  class="form-control"
                  id="department"
                  aria-describedby="emailHelp"
                  v-model="item.department"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group">
                <label for="building">Edificio</label>
                <input
                  type="text"
                  class="form-control"
                  id="building"
                  aria-describedby="emailHelp"
                  v-model="item.building"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="comment">Comentario</label>
                <textarea maxlength="150" class="form-control" aria-label="With textarea" v-model="item.comment"></textarea>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { HTTPFront } from '../../share';
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  props: ["clickedNext", "currentStep"],
  mixins: [validationMixin],
  data() {
    return {
      item: {
        location: '',
        postalCode: '',
        neighborhood: '',
        street: '',
        streetNumber: '',
        floorNumber: '',
        department: '',
        building: '',
        countrySelected: '',
        provinceSelected: '',
        comment: ''
      },
      provinces: null
    };
  },
    validations: {
    item: {
      countrySelected:{
        required
      },
      provinceSelected:{
        required
      },
      location: {
        required
      },
      postalCode:{
        required
      },
      street:{
        required
      },
      streetNumber:{
        required
      },
      neighborhood:{
        required
      }
    }
  },
  created() {
    this.$emit("can-continue", { vale: true });
    this.getData();
  },
    computed: {
    ...mapState(['countries'])
  },
  watch: {
    $v: {
      handler: function (val) {
        if (!val.$invalid) {
          // Formulario válido
          this.$store.commit('setStepTwoData', this.item)          
          this.$emit("can-continue", { value: true });
        } else {
          this.$emit("can-continue", { value: false });
        }
      },
      deep: true,
    },
    clickedNext(val) {
      if (val === true) {
        this.$v.item.$touch();
      }
    },
    currentStep(){
      if(!this.$v.$invalid){
        this.$emit("can-continue", { value: true });
      }
    }
  },
  mounted() {
    if (!this.$v.$invalid) {
      this.$store.commit('setStepTwoData', this.item)          
      this.$emit("can-continue", { value: true });
    } else {
      this.$emit("can-continue", { value: false });
    }
  },
  methods: {
    async getData() {
      this.item.countrySelected = await this.countries.find(country => country.code_iso_alfa3 === 'ARG');
      await this.getProvinces(this.item.countrySelected);
      this.item.provinceSelected = await this.provinces.find(province => province.code_iso === 'AR-X'); // (Córdoba)
    },
    /* Una alternativa */
/*     getProvinces(countrySelected){
      return HTTPFront.get('/getProvincesByCountry/'+ countrySelected.code_iso_alfa3)
      .then(res => {
        this.provinces = res.data;
      })
    }, */
      /* Otra alternativa */
    async getProvinces(countrySelected) {
      this.provinces = (await HTTPFront.get('/getProvincesByCountry/'+ countrySelected.code_iso_alfa3)).data
      },


  }
};
</script>